import List from "./list";
import Invoice from "../models/invoice";
import { excuseApi } from "../commons/http";

export default class Invoices extends List {
  constructor() {
    super();
    this.total = 0;
  }

  mapData(data) {
    this.clear();
    (data || []).forEach((item) => this.add(new Invoice(item)));
  }

  async fetch(page = 1, per_page = 20, params = {}) {
    const res = await excuseApi({
      path: '/invoices',
      method: 'GET',
      params: { page, per_page, ...params },
    });
    if (res.status === 200 || res.status === 201) {
      this.total = res.data.total;
      this.mapData(res.data.data);
    }
    return this.toArray();
  }

  // Eligible billing sources for a customer — FINV-02-S08
  async fetchSources(userId) {
    const res = await excuseApi({
      path: '/invoices/sources',
      method: 'GET',
      params: { user_id: userId },
    });
    if (res.status === 200) {
      return res.data;   // { orders: [...], user_packages: [...] }
    }
    return { orders: [], user_packages: [] };
  }
}
